// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f81230e8","453":"6752a5db","732":"73737fef","977":"7ff9c9d8"}[chunkId] + ".chunk.js";
};